<template>
  <collection-form :value="collection" :title="pageTitle" @submit="save">
    <template slot="actions">
      <form-button kind="submit" type="submit">Enregistrer</form-button>
      <form-button kind="delete" @click="remove">Supprimer</form-button>
      <form-button kind="cancel" @click="$router.go(-1)">Annuler</form-button>
    </template>
  </collection-form>
</template>

<script>
import CollectionForm from "./CollectionForm.vue";

import CollectionDetailQuery from "./graphql/CollectionDetailQuery.gql";
import CollectionUpdateMutation from "./graphql/CollectionUpdateMutation.gql";
import CollectionRemoveMutation from "./graphql/CollectionRemoveMutation.gql";

export default {
  components: {
    CollectionForm
  },
  data() {
    return {
      collection: null
    };
  },
  apollo: {
    collection: {
      query: CollectionDetailQuery,
      skip() {
        return !this.$route.params.id;
      },
      variables() {
        return this.$route.params;
      }
    }
  },
  methods: {
    async save(data) {
      try {
        await this.$apollo.mutate({
          mutation: CollectionUpdateMutation,
          variables: {
            id: this.collection.id,
            data
          }
        });
        this.$store.dispatch(
          "addNotificationSuccess",
          `La collection a été mise à jour !`
        );
        this.$router.push({ name: "collections" });
      } catch (err) {
        if (err.message.match(/duplicate/)) {
          return this.$store.dispatch(
            "addNotificationError",
            `L'alias est déjà utilisé par une autre collection !`
          );
        }
        this.$store.dispatch("addNotificationError", err.message);
      }
    },
    async remove() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CollectionRemoveMutation,
          variables: {
            id: this.collection.id
          }
        });
        if (data.result) {
          this.$store.dispatch(
            "addNotificationSuccess",
            `La collection a été supprimée`
          );
          this.$router.push({ name: "collections" });
        } else {
          this.$store.dispatch(
            "addNotificationError",
            `La collection n'a pas été supprimée`
          );
        }
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/collections/CollectionEdit.vue